import type { CapabilityDefinition } from './types';

const CAPABILITY_REGISTRY = new Map<string, CapabilityDefinition>();

export function registerCapability<TOptions>(def: CapabilityDefinition<TOptions>): void {
  if (CAPABILITY_REGISTRY.has(def.key)) {
    console.warn(`[delivery-type-plugin] capability "${def.key}" already registered, overwriting`);
  }
  CAPABILITY_REGISTRY.set(def.key, def as CapabilityDefinition);
}

export function getCapability(key: string): CapabilityDefinition | undefined {
  return CAPABILITY_REGISTRY.get(key);
}

export function listCapabilities(): CapabilityDefinition[] {
  return [...CAPABILITY_REGISTRY.values()];
}

export function hasCapability(key: string): boolean {
  return CAPABILITY_REGISTRY.has(key);
}
